import React, { useState } from 'react'

import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { Header, Footer, Signout, MobileViewMessage, InternetExplorerMessage } from './components'

import { useIdleTimer } from 'react-idle-timer'
import AuthService from './services/auth'

import { 
  OutageWarning, 
  LandingPage, 
  Instruction,
  OutageMap, 
  Breadcrumbs, 
  InventoryAccountlist, 
  InventoryReferenceInfo,
  InventoryReport,
  SignoutPage,
  IdentityRedirectPage,
  NonNGContacts,
} from './containers'



const App = () => {
  const [isInventory, setIsInventory] = useState(false) 
  const [show, setShow] = useState(true)
  const [savedState, setSavedState] = useState([])
  const onInventoryMount = isInventory => setIsInventory(isInventory)
  const currentLoggedInUser = new AuthService()
 
  const handleOnIdle = (event) => {
    getLastActiveTime()
    if(isInventory === true){
      currentLoggedInUser.logout()
    }
    else{
      window.location.href = '/'
    }
  }

  const handleOnActive = (event) => {
    getRemainingTime()
  }

  const handleOnAction = (e) => {}
 
  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 60,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500,
  })

  return (
    <div className="App">
      <BrowserRouter basename="/">
        {isInventory && show ? (
          <MobileViewMessage setShow={setShow} />
        ) : null}
        {navigator.userAgent.indexOf("rv:11.0") !== -1 && show ? (
          <InternetExplorerMessage setShow={setShow} />
        ) : null}
        <Header />
        <div className="nav-container">
          <Breadcrumbs savedState={savedState} />
          <Signout />
        </div>
        <Switch>
          <Route
            path="/InventoryAccount/InventoryReferenceInfo/InventoryReport"
            render={props => (
              <InventoryReport {...props} onMount={onInventoryMount} />
            )}
          />
          <Route
            path="/InventoryAccount/InventoryReport"
            render={props => (
              <InventoryReport {...props} onMount={onInventoryMount} />
            )}
          />
          <Route
            path="/InventoryAccount/InventoryReferenceInfo"
            render={props => (
              <InventoryReferenceInfo
                {...props}
                savedState={savedState}
                setSavedState={setSavedState}
                onMount={onInventoryMount}
              />
            )}
          />
          <Route
            path="/InventoryAccount"
            render={props => (
              <InventoryAccountlist
                {...props}
                setSavedState={setSavedState}
                onMount={onInventoryMount}
              />
            )}
          />
          <Route path="/OutageWarning/OutageMap/Contacts" component={NonNGContacts} />
          <Route path="/OutageWarning/OutageMap" component={OutageMap} />
          <Route path="/OutageWarning" component={OutageWarning} />
          <Route path="/Instruction" component={Instruction} />
          <Route path="/signout" component={SignoutPage} />
          <Route path="/identityRedirect" component={IdentityRedirectPage} />
          <Route path="/" component={LandingPage} />
        </Switch>
        <Footer />
      </BrowserRouter>
    </div>
  )
}

export default App
